module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmh"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I should like to thank the following for the help kindly given to me: Steven Spencer and colleagues at The Salvation Army International Heritage Centre, London; Lindsay Cox at The Salvation Army Australia Museum; Sarah Pearce at the Heritage Centre & Archives of The Salvation Army NZFTS; Michael Nagy at The Salvation Army Southern Historical Centre, Evangeline Booth College, USA; Ronald Millar at The Salvation Army Archives, Canada and Bermuda Territory, Ontario, Canada; and to all those who generously posted material on Wikimedia Commons.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I should also like to thank the following for their help in allowing me the use of the materials in the epigrams: Adam Peardon-Cook at The Salvation Army Trading Company Ltd.; Rachel Twombly at Rowman & Littlefield, USA.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While every effort has been made to trace the owners of copyright, if it is believed that there are errors or omissions, please notify the publishers in the first instance.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9de1204e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Acknow.vue
// module id = 72
// module chunks = 0